/* eslint-disable prettier/prettier */
import Checkbox from "@mui/material/Checkbox";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";
export { GridActionsCellItem } from "@mui/x-data-grid";

function GenericTable({ 
  tableData, 
  pagination, 
  rowSelectionModel, 
  checkboxSelection, 
  onRowSelectionModelChange,
  ...props }) {
  const initialModel =
    pagination && pagination.model
      ? pagination.model
      : { page: 0, pageSize: 10 };
  const [paginationModel, setPaginationModel] = useState(initialModel);

  const onPaginationModelChange = (data) => {
    setPaginationModel(data);
  };

  useEffect(() => {
    if (pagination && typeof pagination.callData === "function") {
      pagination.callData(paginationModel);
    }
  }, [paginationModel, pagination]);

  const defaultGetRowId = (row) => {
    if (!row || typeof row !== "object") return String(row);
    return (
      row.id ??
      row._id ??
      row.uuid ??
      row.key ??
      row.code ??
      row.variableId ??
      (row.name ? `name:${row.name}` : undefined) ??
      JSON.stringify(row)
    );
  };
  
  const rawRows = tableData && tableData.data ? tableData.data : [];
  const rowsWithIndex = useMemo(() => {
    return (rawRows || []).map((row, index) => {
      const tableDataObj =
        row && typeof row === "object" ? row.tableData || {} : {};
      return { ...row, tableData: { ...tableDataObj, id: index } };
    });
  }, [rawRows]);

  const legacyHeaders = tableData && tableData.headers ? tableData.headers : [];
  const columns = useMemo(() => {
    return (legacyHeaders || []).map((col, idx) => {
      const field = col.field || `col_${idx}`;
      const mappedCol = {
        ...col,
        field,
        headerName: col.headerName || col.title || field,
        flex: col.flex ?? (col.width || col.minWidth ? undefined : 1),
      };

      if (col.render && !col.renderCell) {
        mappedCol.renderCell = (params) => col.render(params.row);
      }

      if (field === "principal") {
        mappedCol.renderCell = (params) => {
          const isMain = params?.row?.tableData?.id === 0;

          const checkbox = col.hideCheckbox ? null : (
            <Checkbox
              size="small"
              checked={!!isMain}
              onChange={() => {
                if (typeof col.formatFunction === "function") {
                  col.formatFunction(params.row, field);
                }
              }}
            />
          );

          if (typeof col.render === "function") {
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  width: "100%",
                }}
              >
                {checkbox}
                {col.render(params.row)}
              </div>
            );
          }

          return checkbox;
        };
      }
      return mappedCol;
    });
  }, [legacyHeaders]);

  return (
    <DataGrid
      {...props}
      getRowId={props.getRowId || defaultGetRowId}
      paginationModel={paginationModel}
      rowCount={pagination && pagination.totalElements}
      rows={rowsWithIndex}
      checkboxSelection={checkboxSelection}
      rowSelectionModel={rowSelectionModel}
      onRowSelectionModelChange={onRowSelectionModelChange}
      columns={columns}
      disableRowSelectionOnClick
      onPaginationModelChange={onPaginationModelChange}
      hiddenSearch={false}
      pageSizeOptions={[10, 25, 50, 100]}
    />
  );
}

export default GenericTable;
